(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ama-image-carousel"] && !Shopify.designMode) return;
  try {
    
  class ImageCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.image-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.image-carousel__slide'));
      if (this.slides.length < 2) return;

      this.prevBtn = this.querySelector('.image-carousel__nav--prev');
      this.nextBtn = this.querySelector('.image-carousel__nav--next');
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) || 3000;
      this.clonesPerSide = 2;

      this.setupClones();
      this.currentIndex = this.clonesPerSide;
      this.measure();
      this.applyTransform(false);

      this.prevBtn?.addEventListener('click', () => this.go(-1));
      this.nextBtn?.addEventListener('click', () => this.go(1));
      window.addEventListener('resize', this.onResize);

      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.removeEventListener('resize', this.onResize);
    }

    setupClones() {
      const n = this.slides.length;
      for (let i = 0; i < this.clonesPerSide; i++) {
        this.track.appendChild(this.slides[i % n].cloneNode(true));
        this.track.insertBefore(
          this.slides[(n - 1 - i + n) % n].cloneNode(true),
          this.track.firstChild
        );
      }
    }

    measure = () => {
      const slide = this.track.children[0];
      if (!slide) return;
      const style = window.getComputedStyle(slide);
      this.slideWidth =
        slide.offsetWidth +
        parseFloat(style.marginLeft) +
        parseFloat(style.marginRight);
    };

    onResize = () => {
      this.measure();
      this.applyTransform(false);
    };

    applyTransform(animate) {
      this.track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      this.track.style.transform = `translateX(-${this.currentIndex * this.slideWidth}px)`;
    }

    go(direction) {
      this.currentIndex += direction;
      this.applyTransform(true);

      const n = this.slides.length;
      const lastOriginal = this.clonesPerSide + n - 1;

      if (this.currentIndex > lastOriginal) {
        setTimeout(() => {
          this.currentIndex = this.clonesPerSide;
          this.applyTransform(false);
        }, 500);
      } else if (this.currentIndex < this.clonesPerSide) {
        setTimeout(() => {
          this.currentIndex = lastOriginal;
          this.applyTransform(false);
        }, 500);
      }
    }

    startAutoplay = () => {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.go(1), this.speed);
    };

    stopAutoplay = () => {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    };
  }

  if (!customElements.get('image-carousel')) {
    customElements.define('image-carousel', ImageCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
